import React from 'react';
import Cookies from 'js-cookie';
import _ from 'lodash';
import Sorting from './Sorting';
// import SearchBar from 'material-ui-search-bar'
import Loader from 'react-loader-spinner'

import '../css/D2HShowsAi.css';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
// import createHistory from 'history/createBrowserHistory';
;

//d2h shows ai page ai section
class D2HShowsAi extends React.Component{
  state={
      logdata: [],
      actualData: [],
      searchValue: '',
      sortedType: '',
      searchActive: false,
  loadSpinner: true,

    }


componentDidMount(){
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  fetch('/cloud/aishowsdata' ,{
      method: "GET",
      headers: headers,
  })
           .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
  .then(data => {
    console.log('data ' , data)
      this.setState({
        logData: data,
        actualData: data
      },()=>{
        this.setState({
          loadSpinner: false
        })
      })
  })
  .catch((err)=>{
    console.log(err)

  })
}    

    
  restoreData = (data) => {
    this.setState({
      logData: data
    })
 }
   sortingFunc = (type,searchValue) => {
     if(this.state.sortedType!==type && type!=='search' ){
       this.setState({
         sortedType: type
       })
     Sorting(this.restoreData, type, this.state.logData);
     }else if(type==='search'){
       type='search';
       Sorting(this.restoreData, type, this.state.actualData,searchValue);
     }else{
       type='reverse';
     Sorting(this.restoreData, type, this.state.logData);
     }
   }
 


    render(){
        return (
          <div className="movies">
                       { this.props.redux.auth.searchBarShow ?  <div className='animated animated-duration-custom slideInDown pb-3 mx-4'>
                        <IntegrationReactSelectNew  autoFocus
                                    value={this.state.searchValue}
                                    onChange={(e)=>{                  
                                      this.setState({
                                        searchValue: e
                                      },()=>{
                                        this.sortingFunc('search',this.state.searchValue)
                                      })
                                    }
                                  }  
                                  onRequestSearch={() => this.sortingFunc('search',this.state.searchValue)}
                                  /></div> : null}
          <h3 className="ai-heading dashboard-ai-heading ml-5">D2h Shows User Data</h3>
          {!this.state.loadSpinner ?   
          <div className="si-list">    
                <table className="table table-striped table-hover table-fixed">
                  <thead className="tableHeaderColor">
                    <tr>
                      <th scope="col">ID <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('ID')}}></i> </th>
                      <th scope="col">User ID <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('userId')}}></i></th>
                      <th scope="col">Room ID <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('roomId')}}></i></th>
                      <th scope="col">Channel <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('channelName')}}></i></th>
                      <th scope="col">Program <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('programName')}}></i></th>
                      <th scope="col">Rating <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('rating')}}></i></th>
                      <th scope="col">In Time <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('in_time')}}></i></th>
                      <th scope="col">Out Time <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('out_time')}}></i></th>
                      <th scope="col">Duration <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('duration')}}></i></th>
                      <th scope="col">Room Type <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('roomtype')}}></i></th>
                    </tr>

                  </thead>
                  <tbody>
                  {this.state.logData.map((e,index)=>{
                      return (
                        <tr key={index} className="some-hover">
                          <th scope="row">{e.ID}</th>
                          <th scope="row">{e.userId}</th>
                          <td>{e.roomId}</td>
                          <td>{e.channelName}</td>
                          <td>{e.programName}</td>
                          <td>{e.rating}</td>
                          <td>{e.in_time}</td>
                          <td>{e.out_time}</td>
                          <td>{e.duration}</td>
                          <td>{e.roomtype}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
          </div> :   <div className="spinnerLoad" style={{'marginTop': '12%', 'marginLeft': '45%'}}>
          <Loader 
	     type="Bars"
	     color="#f89500"
	     height="75"	
	     width="75"
	  />    
          </div> }
          </div>
        );
    }
}


const mapStateToProps = state  => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({type: ActionTypes.SEARCHBAR, data: data }),
  };
};


export default connect(mapStateToProps, mapDispatchToProps) (D2HShowsAi);
